export { default } from './SelectOneOfType';
